module.exports = __webpack_public_path__ + "img/LT110086034.74e9a404.png";